
import { CardHeader, CardContent, CardActions, } from '@mui/material';
import MofService from '../../../../services/mof';
import { Modal } from 'antd';
import { Toast } from '../../../../utils/alerts';
import { CODES } from '../../../../utils/responseCodes';
import { Box } from '@mui/system';
import AddRegisterMofsV2 from '../../../components/MofV2/AddMofs/AddRegisterMofsV2';
import Swal from 'sweetalert2';
import React, { useState, useEffect } from "react";

const AddRegisterMof = (props) => {
  const { userToken,getAprobado,open, handleClose, listarMof, setOpenModalLoader, puesto, companies, datosMof,
    setDatosMof, puestoId, setPuestoId, companieId, setCompanieId, clienteId, setClienteId
    , mofId,  staff, setStaff, basc, setBasc,idUsuario,setMofId, opcionVer, mofxUsuarioBody,idPerfil,personaAprobacion,setPersonaAprobacion,getDatosMof} = props;
   
    const [porcentaje, setPorcentaje] = useState(0);
   
  

    useEffect(() => {
      const excluirIDs = [22, 23, 24, 25, 26, 27, 127, 128, 129, 130, 131, 135, 136, 132, 133]; // IDs a excluir
      const datosFiltrados = datosMof.filter(item => !excluirIDs.includes(item.id_preguntamof));
      const total = datosFiltrados.length;
    
      const llenos = datosFiltrados.filter(item => {
        if (!item?.detalle_mof) return false; // Si detalle_mof es null, descartar
    
        if (+item.tipoRespuesta_id === 1) {
          // Tipo de respuesta 1: Evaluar solo "respuesta"
          return item.detalle_mof.respuesta !== "";
        } else if (+item.tipoRespuesta_id === 2) {
          // Tipo de respuesta 2: Evaluar solo "respuesta_id"
          return item.detalle_mof.respuesta_id !== null;
        }
    
        return false;
      }).length;
      setPorcentaje(total > 0 ? ((llenos / total) * 100).toFixed(2) : 0);
    }, [datosMof]);
    




  const cleanInfo = () => {
    setPuestoId(null);
    setMofId(null);
    setCompanieId(null);
    setClienteId(null);
    setDatosMof([]);
    handleClose();
    setPersonaAprobacion(null);
    setPorcentaje(0);
  }

  const mostrarCodigoMof = (codigo) => {
    Swal.fire({
      icon: 'success',
      title: 'MOF guardado correctamente',
      html: `
        <div style="margin-top:10px;">
          <strong>Código generado:</strong>
  
          <div id="codigoMof"
            style="
              margin-top:8px;
              padding:10px;
              background:#f4f4f4;
              border-radius:6px;
              font-family:monospace;
              user-select:all;
              word-break:break-all;
            ">
            ${codigo}
          </div>
  
          <button id="copiarCodigo"
            style="
              margin-top:10px;
              padding:6px 12px;
              background:#3085d6;
              color:white;
              border:none;
              border-radius:4px;
              cursor:pointer;
            ">
            Copiar código
          </button>
        </div>
      `,
      showConfirmButton: false,
      didOpen: () => {
        const btn = document.getElementById('copiarCodigo');
        btn.addEventListener('click', async () => {
          await navigator.clipboard.writeText(codigo);
          Swal.close(); // 🔥 se cierra automáticamente
        });
      }
    });
  };

  const guardado = async (e) => {
    e.preventDefault();
    if (puestoId === null || puestoId === "" || clienteId === null || clienteId === "") {
      Toast.fire({
        icon: 'warning',
        title: 'Falta Puesto o Cliente'
      });
      return;
    }
    // Mostrar alerta de confirmación
    const result = await Swal.fire({
      title: '¿Deseas guardar?',
      html: "Asegúrate de que todos los datos son correctos.<br><br>",
      icon: 'warning',

      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'No, cancelar'
    });
    if (result.isConfirmed) {
      setOpenModalLoader(true);
    
      try {
        // Filtrar datosMof excluyendo los objetos con id_preguntamof 125 y 126
        const datosMofFiltrados = datosMof.filter(item => item.id_preguntamof !== 125 && item.id_preguntamof !== 126);
        // Verificar si algún objeto en datosMofFiltrados tiene detalle_mof igual a null
        const isDetalleMofNull = datosMofFiltrados.some(item => item.detalle_mof === null || item.detalle_mof === "");
        let estado=1;
        const result = await MofService.saveMof(datosMof, puestoId, clienteId, mofId, estado,porcentaje);
       
        if (result.status === CODES.SUCCESS_200) {

          const idParaActualizar = mofId ? mofId : result.data?.id_mof;
          if (idParaActualizar) {
            await MofService.actualizarStaffBasc(idParaActualizar, 'staff', staff);
            await MofService.actualizarStaffBasc(idParaActualizar, 'basc', basc);
          }

          Toast.fire({
            icon: 'success',
            title: result.data.message || 'Éxito en el registro Mof'
          });
        
          // 👇 MOSTRAR CODIGO MOF SI EXISTE
          if (result.data?.codMof) {
            mostrarCodigoMof(result.data.codMof);
          }
          cleanInfo();
        
        } else {
          Toast.fire({
            icon: 'error',
            title: (result?.response?.data?.message || 'Error en el registro Mof')
          });
        }
        return [];
      } catch (error) {
        console.log(`Error en guardado: ${error}`);
      } finally {
        listarMof();
        setOpenModalLoader(false);
      }
    } else {
      Toast.fire({
        icon: 'info',
        title: 'Operación cancelada'
      });
    
      let html = "";
      for (let i = 0; i < datosMof.length; i++) {
        // Verifica si el detalle_mof está vacío y si el id_preguntamof no es 128, 129 o 130
        if (!datosMof[i]["detalle_mof"] && ![128, 129, 130,132,133,135,136].includes(datosMof[i]["id_preguntamof"])) {
          /*Toast.fire({
            icon: 'warning',
            title:  `Falta completar ${datosMof[i]["descripcion"]}`
          });*/
          html += `${datosMof[i]["descripcion"]?.toUpperCase()} <br/> `;
        }
      }
    
      Swal.fire({
        title: "Faltan completar estos campos",
        icon: "warning",
        html: html,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      });
    }
  };


  return (
    <Modal
      title={
        <CardHeader
          title={"Registro de MOF"}
          subheader={"Informacion completa del mof"}
          sx={{
            paddingBottom: "0.3rem",
            paddingTop: 0,
            margin: "-0.5rem -1rem -0.1rem -1rem",
            borderBottom: `solid 0.05rem #D5DBDB`
          }}
        />
      }
      open={open}
      onOk={cleanInfo}
      onCancel={cleanInfo}
      destroyOnClose={true}
      footer={null}
      style={{ top: "10%" }}
      width={"90%"}
    >
      <Box sx={{ overflow: "scroll", p: 2, backgroundColor: "#" }}>
        <form onSubmit={guardado}>
          <CardContent
            sx={{
              padding: 0,
              margin: "0 -0.5rem", backgroundColor: ""
            }}
          >
            <AddRegisterMofsV2
              setOpenModalLoader={setOpenModalLoader}
              puesto={puesto} companies={companies}
              datosMof={datosMof} setDatosMof={setDatosMof}
              puestoId={puestoId} setPuestoId={setPuestoId}
              companieId={companieId} setCompanieId={setCompanieId}
              clienteId={clienteId} setClienteId={setClienteId}
              opcionVer={opcionVer} mofxUsuarioBody={mofxUsuarioBody}
              idPerfil={idPerfil} userToken={userToken}
              mofId={mofId} idUsuario={idUsuario} personaAprobacion={personaAprobacion} setPersonaAprobacion={setPersonaAprobacion} getAprobado={getAprobado}
              staff={staff} basc={basc} setBasc={setBasc} setStaff={setStaff}
              guardado={guardado} getDatosMof={getDatosMof} listarMof={listarMof}
             
            />
          </CardContent>
          <CardActions
            sx={{
              margin: "0.5rem -1rem -1rem -1rem",
              borderTop: `solid 0.05rem #00337C`, backgroundColor: ""
            }}
          >
            {opcionVer !== 5 && (
              <button
                type={"submit"}
                className="btn btn-primary btn-sm"
                style={{ fontSize: "15px" }}
              >
                Guardar
              </button>
            )}
            <button
              type={"button"}
              onClick={cleanInfo}
              className="btn btn-danger btn-sm"
              style={{ fontSize: "15px" }}
            >
              Cerrar
            </button>
            {/*(idPerfil === 16 || idPerfil ===1 ) && (
              <button
                type={"submit"}
               // onClick={guardado}
                className="btn btn-info btn-sm"
                style={{ fontSize: "15px" }}
              >
                Aprobar
              </button>
            )*/}
          </CardActions>
        </form>
      </Box>
    </Modal>
  );
};


  





export default AddRegisterMof;